import { getEnvVar } from "@dashboard/common/utils";

export const getAssistantId = () => {
  return getEnvVar("REACT_APP_ASSISTANT_ID");
};
